export default __webpack_public_path__ + "static/media/designer-integration.fa21f1fd.png";